var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpicImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243,
    height: 70,
    viewBox: "0 0 243 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7905 23.5039H46.2324V23.5336H57.7905V23.5039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3482 15.6184V43.0336C69.3482 45.0868 67.695 46.7497 65.6538 46.7497H23.1161V35.124H57.7902V23.4983H11.558V58.3754H69.3482V66.285C69.3482 68.3382 67.695 70.0011 65.6538 70.0011H3.69444C1.65326 70.0011 0 68.3382 0 66.285V15.6184C0 13.5653 1.65326 11.9023 3.69444 11.9023H65.6538C67.695 11.9023 69.3482 13.5653 69.3482 15.6184Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4642 58.3754H150.254V66.285C150.254 68.3382 148.601 70.0011 146.56 70.0011H84.5987C82.5576 70.0011 80.9043 68.3382 80.9043 66.285V15.6184C80.9043 13.5653 82.5576 11.9023 84.5987 11.9023H146.56C148.601 11.9023 150.254 13.5653 150.254 15.6184V23.4983H92.4642V58.3754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.492 35.125V46.7507H188.628C186.587 46.7507 184.934 45.0878 184.934 43.0346V35.125H196.492Z",
    fill: "#F4F4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.042 46.75V58.3757H200.179C198.138 58.3757 196.484 56.7128 196.484 54.6596V46.75H208.042Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.222 0H229.776C227.506 0 225.664 1.85246 225.664 4.13598V5.392C225.664 5.62426 225.851 5.81192 226.082 5.81192H236.805C237.036 5.81192 237.222 5.99958 237.222 6.23183V17.0177C237.222 17.25 237.409 17.4376 237.64 17.4376H239.306C241.347 17.4376 243 15.7747 243 13.7216V4.13598C243 1.85246 241.159 0 238.888 0H237.222Z",
    fill: "#F4F4F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.161 15.6184V43.0336C231.161 45.0868 229.508 46.7497 227.466 46.7497H196.487V35.124H219.603V23.4983H173.371V70.0011H165.507C163.466 70.0011 161.812 68.3382 161.812 66.285V15.6184C161.812 13.5653 163.466 11.9023 165.507 11.9023H227.466C229.508 11.9023 231.161 13.5653 231.161 15.6184Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.045 58.3711H219.603V69.9968H211.739C209.7 69.9968 208.045 68.332 208.045 66.2807V58.3711Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicImg);
export default __webpack_public_path__ + "static/media/EpicImg.8dbc3b62240f717a27707c8de566190d.svg";
export { ForwardRef as ReactComponent };